import {
  Component,
  Input,
  OnInit,
  OnDestroy,
} from '@angular/core';
import {Website} from "../website/website";
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {DbStoreState} from "../../store";
import {Store} from '@ngrx/store';
import {Router} from "@angular/router";
import {GoogleAnalyticsService} from "../../shared/services/google-analytics/google-analytics.service";
import {Subject} from "rxjs";
import {DbModalService} from "../../modules/modal/modal";
import {RemoveWebsiteComponent} from "../remove-website/remove-website.component";

@Component({
    selector: 'db-website-item-list-view',
    templateUrl: './website-item-list-view.component.html',
    styleUrls: ['./website-item-list-view.component.scss'],
    standalone: false
})
export class WebsiteItemListViewComponent  implements OnInit, OnDestroy {

  @Input() website: Website;
  @Input() subscriptionId?: number;
  @Input() disableMigrateButton?: boolean;
  @Input() isRootSubSite?: boolean;

  public websiteUrl: string;

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _dialogService: DialogService,
    private _store: Store<DbStoreState>,
    private _router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _modalService: DbModalService,
  ) {}

  public manageWebsite(): void {
    this._router.navigate(['/websites/' + this.website.id]);
  }

  ngOnInit() {
    this.websiteUrl = this.website.site_url.replace(/^https?:\/\//i, '');
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  public removeWebsite(): void {
    const modal = this._modalService.open(RemoveWebsiteComponent);
    modal.componentInstance.website = this.website;
  }
}
